import AddressForm from 'components/Address/AddressForm/AddressForm';
import ErrorScrolling from 'components/Forms/utilities/ErrorScrolling';
import { manualAddressErrorOrder as errorOrder } from 'components/Address/util';

export default ({ submitText = 'Save', onSubmit, ...otherProps }) =>
  ErrorScrolling({
    ...otherProps,
    datatag: 'address-form',
    submitText,
    submitResult: onSubmit,
    errorOrder,
  })(AddressForm);
